import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import CustomerSwitcher from 'components/CustomerSwitcher'
import { selectUser, selectCustomerLabels } from '../App/selectors'
import { getCustomers, getCustomer } from 'helpers'
import { OptionsHOC } from '../../hocs'

const CustomerSwitcherContainer = ({
  user,
  customerLabels,
  getOption,
  ...props
}) => {
  const changeCustomer = ({ value }) => {
    sessionStorage.setItem('customer', value)
    window.location.replace(`${window.location.origin}?customer=${value}`)
  }

  const changeLabel = (customer) => {
    if (!customerLabels) return

    const label = customerLabels.find((val) => val.customer === customer)

    if (!label) return

    return label.name
  }

  const generateProps = () => ({
    ...props,
    customers: getCustomers(user.careassist).map((customer) => ({
      value: customer,
      label: changeLabel(customer) || customer
    })),
    changeCustomer: changeCustomer,
    customer: getCustomer(),
    displayName: getOption('displayName'),
    callhandlerEnabled: getOption('callHandler.enabled')
  })

  return <CustomerSwitcher {...generateProps()} />
}

const mapStateToProps = (state) => ({
  user: selectUser(state),
  customerLabels: selectCustomerLabels(state)
})

CustomerSwitcherContainer.propTypes = {
  user: PropTypes.shape({
    name: PropTypes.string.isRequired,
    multiLoginCustomers: PropTypes.arrayOf(PropTypes.string),
    careassist: PropTypes.shape({
      name: PropTypes.string.isRequired
    }).isRequired
  })
}

export default OptionsHOC(connect(mapStateToProps)(CustomerSwitcherContainer))
